export default __webpack_public_path__ + "static/media/CU41.3936c12e.jpg";